import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=353ea32d&scoped=true&"
import script from "./FolderItem.vue?vue&type=script&lang=js&"
export * from "./FolderItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=353ea32d&lang=scss&scoped=true&"
import style1 from "./FolderItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ea32d",
  null
  
)

export default component.exports